import { Snackbar } from '@cian/ui-kit';
import cn from 'classnames';

import * as styles from './styles.css';

interface IProps {
  className?: string;
  isOpen: boolean;
  message: string;
}

export function ErrorSnackbar({ className, isOpen, message }: IProps) {
  return (
    <div className={cn(styles['snackbar'], className)}>
      {isOpen && (
        <Snackbar
          open={isOpen}
          status="error"
          message={message}
          hideCloseButton
          anchorOrigin={{
            // @ts-expect-error
            vertical: 'bottom',
            horizontal: 'center',
          }}
        />
      )}
    </div>
  );
}
